goog.provide("shadow.js.shim.module$src$svg$path$path_split_right_svg");
goog.provide("module$shadow_js_shim_module$src$svg$path$path_split_right_svg");
shadow.js.shim.module$src$svg$path$path_split_right_svg = shadow.js.nativeProvides["src/svg/path/path-split-right.svg"] = shadow$bridge("src/svg/path/path-split-right.svg");
module$shadow_js_shim_module$src$svg$path$path_split_right_svg.default = shadow.js.shim.module$src$svg$path$path_split_right_svg;
